module.exports = __webpack_public_path__ + "img/Partnersimg3.214dc2d1.png";